import { Dropdown } from "primereact/dropdown";

export const getDropdownValue = (ddlData) => {
    if (!ddlData) return;

    let exctractedDropdownValue = ddlData && typeof ddlData === 'object' ? ddlData.value : ddlData;


    return exctractedDropdownValue;

};

export const getDropdownLabel = (ddlData) => {
    if (!ddlData) return;

    let exctractedDropdownValue = ddlData && typeof ddlData === 'object' ? ddlData.label : ddlData;


    return exctractedDropdownValue;

};


export const getSelectedDropdownObject = (selectedValue, optionList) => {
    if (!(selectedValue || optionList)) return;

    let extractedValue = getDropdownValue(selectedValue);

    let selectedValueObj = optionList.find(item => item.value === extractedValue);

    return selectedValueObj
};

// Define your custom dropdown renderer
export const customRowsPerPageDropdown = (options, value = 10) => {
  // Add "All" option at the end
  const dropdownOptions = [...options?.options, { label: "All", value: 99999 }];

  return (
    <Dropdown
      value={value}
      options={dropdownOptions}
      onChange={options.onChange}
    />
  );
};